export * from "../../base/store/mutations";

export function set_empty_item(state, item) {
	state.empty_item = item;
}
